// extracted by mini-css-extract-plugin
export default {"main":"CustomRating_main__Z-7zr","icon":"CustomRating_icon__mYtJj","icon--inactive":"CustomRating_icon--inactive__hb24g"};